export default __webpack_public_path__ + "static/media/Hero-avatar.2d0923c8.png";